import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NbToastrService, NbDialogRef } from '@nebular/theme';
import { EventSendeurService } from '../event-sendeur.service';
import { Config } from '../../config/config';

@Component({
  selector: 'ngx-mediatheque',
  templateUrl: './mediatheque.component.html',
  styleUrls: ['./mediatheque.component.scss']
})
export class MediathequeComponent implements OnInit {

  @Input() mime;
  url;
  fichierUrl;
  dataFichier:any = [];
  hideModal = false;
  constructor(protected dialogRef: NbDialogRef<MediathequeComponent>,private sanitizer: DomSanitizer,private toastrService: NbToastrService, private eventSendeur:EventSendeurService) { 
    window.addEventListener('message', this.handleIframeTask);
   
  }

  ngOnInit() {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl( Config.urlserveur + Config.urlmediatheque + "?mime=" + this.mime);

  }

  close(){
    this.dialogRef.close();
  }

  onLoad(){

    // alert('');
  }

  handleIframeTask = (e) => {
    if (e.data.baseUrl && e.data.baseUrl =="/mediatheque/" ) {
     
      /* if (e.data.mime ==="application/pdf"){
        this.toastrService.info("Seuls les fichiers jpg, png et jpeg sont pris en compte dans les publications ");
      }else{ */

      /* localStorage.removeItem("fichier");
      localStorage.setItem("fichier",JSON.stringify(e.data));
      // this.toastrService.success("Votre fichier a bien été pris en compte");
      if(localStorage.getItem("photo") ==="image"){
        this.fichierUrl = "https://apismid.cotafric.net" + e.data.tmb;

        localStorage.removeItem("fichier");
        localStorage.setItem("fichier",JSON.stringify(e.data));
        this.eventSendeur.sendImage(this.fichierUrl);
      }

      if(localStorage.getItem("photo") ==="fichier"){
        this.fichierUrl = "https://apismid.cotafric.net" + e.data.url;

        localStorage.removeItem("fichier");
        localStorage.setItem("fichier",JSON.stringify(e.data));
        this.eventSendeur.sendFile(this.fichierUrl);
      } */

      delete e.data.read;
      delete e.data.write;
    
      if(this.mime ==="image"){
        this.eventSendeur.image.next(e.data);
      }

      if(this.mime ==="all"){
        this.eventSendeur.fichier.next(e.data);
      }
      
      this.dialogRef.close();

      // }
     
      // if ( /\.(jpg||jpeg||png)$/i.test(this.fichierUrl.name) ){
      //   localStorage.removeItem("fichier");
      //   localStorage.setItem("fichier",JSON.stringify(e.data));
      //   this.toastrService.success("Votre fichier a été bien pris en compte");
      //   this.dialogRef.close();
      // }else{
      //   this.toastrService.danger("seuls les fichiers jpg, png ou jpeg sont pris en compte");
      // }
      
     
    }
    // if (e.data) {
    //   localStorage.removeItem("fichier");
     
    //   console.log(e.data);
    //   alert(e.data);
     
    //   this.fichierUrl = "https://apismid.cotafric.net"+e.data.url;
    //   localStorage.setItem("fichier",this.fichierUrl);
    
    // }
  };


}
